import httpService from "./httpService";

export default {

  create(form) {
    return httpService.post("tkTaskCopy", form);
  },
  saveCopy(form) {
    return httpService.post("tkTaskCopy/saveCopy", form);
  },

  findById(id) {
    return httpService.get("tkTaskCopy/findById/" + id);
  },
}



// WEBPACK FOOTER //
// ./src/services/tkTaskCopyService.js